/**
 * Parser für `ChinaAppSysView.DefaultOrder` — Port des `<GridSortColumns>`-Blocks aus
 * `IwmDataGridBase.razor`.
 */

import type { GridSort } from './types';

/**
 * Zerlegt `"Feld asc, Feld2 desc"` in Sortierungen.
 *
 * Der Altclient rendert die Einträge in **umgekehrter** Reihenfolge (`.Reverse()`);
 * diese Reihenfolge wird übernommen, weil sie die Sortierrangfolge bestimmt.
 */
export function parseDefaultOrder(defaultOrder: string | null | undefined): GridSort[] {
  if (defaultOrder === null || defaultOrder === undefined) return [];

  return defaultOrder
    .split(',')
    .reverse()
    .map((entry) => entry.trim().split(' '))
    .filter((parts) => parts[0] !== undefined && parts[0] !== '')
    .map((parts) => ({
      field: parts[0] ?? '',
      direction: (parts[1] ?? '').toLowerCase().includes('desc')
        ? ('descending' as const)
        : ('ascending' as const),
    }));
}
